import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ArrowRight } from 'lucide-react';
import logoLight from '../assets/images/hande_logo_light.png';

const SplashScreen: React.FC = () => {
  // const navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     navigate('/account-type');
  //   }, 3000);

  //   return () => clearTimeout(timer);
  // }, [navigate]);

  // const handleGetStarted = () => {
  //   navigate('/account-type');
  // };

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Enhanced Gradient Background */}
      {/* <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 via-purple-900 to-black animate-pulse"></div> */}
      <div className="absolute inset-0 bg-gradient-to-r from-black via-gray-800 to-white"></div>
      
      {/* Animated Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/5 to-transparent animate-pulse"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent via-purple-500/10 to-transparent animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4">
        {/* Logo/Brand */}
        <div className={`text-center mb-8 transition-all duration-1000 ${isLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-75'}`}>
          <div className="mb-8 flex justify-center">
            <img
              src={logoLight}
              alt="Startup Hande"
              className="h-24 md:h-32 lg:h-40 w-auto"
            />
          </div>
          <h1 className="text-6xl md:text-9xl lg:text-[12rem] font-black text-transparent bg-clip-text bg-gradient-to-r from-gray-300 via-white to-gray-300 mb-4 tracking-wider drop-shadow-2xl shadow-black animate-pulse">
            STARTUP HAND
          </h1>
          <div className="w-64 h-1 bg-gradient-to-r from-transparent via-gray-400 to-transparent mx-auto animate-pulse"></div>
        </div>

        {/* Coming Soon Button */}

        {/* <button
          onClick={handleGetStarted}
          className={`group relative flex items-center justify-center w-48 h-12 bg-gradient-to-r from-gray-800 to-gray-300 rounded-full border border-gray-400 hover:from-gray-700 hover:to-gray-200 transition-all duration-300`}
          style={{ transitionDelay: '500ms' }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent rounded-full animate-pulse"></div>
          <ArrowRight className="w-10 h-10 text-white group-hover:text-white group-hover:translate-x-3 transition-all duration-300 drop-shadow-lg" />
          <span className="absolute -bottom-8 text-gray-300 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">GET STARTED</span>
        </button> */}


        <button
          type="button"
          disabled
          className="relative flex items-center justify-center w-48 h-12 bg-gradient-to-r from-gray-800 to-gray-300 rounded-full border border-gray-400 opacity-80 cursor-not-allowed"
          style={{ transitionDelay: '500ms' }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent rounded-full animate-pulse" />
          <span className="relative text-gray-100 text-sm font-semibold tracking-wide">
            Coming Soon...
          </span>
        </button>

        {/* Loading Indicator */}
        {/* <div className={`mt-12 flex space-x-3 ${isLoaded ? 'opacity-100' : 'opacity-0'}`} style={{ transitionDelay: '1000ms' }}>
          <div className="w-3 h-3 bg-gray-400 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="w-3 h-3 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div> */}
      </div>

      {/* Enhanced Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-40 h-40 border-2 border-gray-400 rounded-full animate-spin" style={{ animationDuration: '20s' }}></div>
        <div className="absolute top-3/4 right-1/4 w-32 h-32 border-2 border-gray-400 rounded-full animate-spin" style={{ animationDuration: '15s', animationDirection: 'reverse' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-24 h-24 border-2 border-gray-400 rounded-full animate-spin" style={{ animationDuration: '25s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 border border-gray-400 rounded-full animate-pulse"></div>
      </div>
    </div>
  );
};

export default SplashScreen; 